import { useEffect, useRef } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogViewFavoriteMarket = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const hasLoggedRef = useRef(false);

  useEffect(() => {
    if (hasLoggedRef.current) return;
    hasLoggedRef.current = true;
    logAnalyticsEvent({
      name: 'VIEW_FAVORITE_MARKET',
    });
  }, [logAnalyticsEvent]);
};
